"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var install_1 = require("./install");
var isProduction = process.env.NODE_ENV === 'production';
var levels = ['debug', 'info', 'warn', 'error', 'log'];
var defaultOptions = {
    enabled: true,
    consoleEnabled: true,
    level: 'debug',
    callerInfo: false,
    prefixFormat: function (_a) {
        var level = _a.level, caller = _a.caller;
        return (caller
            ? "[".concat(level.toUpperCase(), "] [").concat(caller === null || caller === void 0 ? void 0 : caller.fileName, ":").concat(caller === null || caller === void 0 ? void 0 : caller.functionName, ":").concat(caller === null || caller === void 0 ? void 0 : caller.lineNumber, "]")
            : "[".concat(level.toUpperCase(), "]"));
    }
};
var VueLogger = (function () {
    function VueLogger(options) {
        this.install = install_1.install;
        this.apply(options);
        this._consoleFunctions = levels.filter(function (lvl) { return typeof console[lvl] === 'function'; });
    }
    VueLogger.prototype.apply = function (options) {
        var fallback = this._options || defaultOptions;
        this._options = __assign(__assign({}, fallback), options);
        this.installHooks(this._options.beforeHooks);
        this.installHooks(this._options.afterHooks);
    };
    VueLogger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._invoke.apply(this, __spreadArray(['debug'], args, false));
    };
    VueLogger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._invoke.apply(this, __spreadArray(['info'], args, false));
    };
    VueLogger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._invoke.apply(this, __spreadArray(['warn'], args, false));
    };
    VueLogger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._invoke.apply(this, __spreadArray(['error'], args, false));
    };
    VueLogger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._invoke.apply(this, __spreadArray(['log'], args, false));
    };
    VueLogger.prototype._invoke = function (level) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this._options.enabled && levels.indexOf(level) >= levels.indexOf(this._options.level)) {
            var caller = this._options.callerInfo ? this.getCallerInfo() : undefined;
            var event_1 = { level: level, caller: caller, argumentArray: args };
            this.invokeHooks(this._options.beforeHooks, event_1);
            if (this._options.consoleEnabled) {
                var msgPrefix = this._options.prefixFormat({ level: level, caller: caller });
                if (this._consoleFunctions.indexOf(level) >= 0) {
                    console[level].apply(console, __spreadArray([msgPrefix], args, false));
                }
                else {
                    console.log.apply(console, __spreadArray([msgPrefix], args, false));
                }
            }
            this.invokeHooks(this._options.afterHooks, event_1);
        }
    };
    VueLogger.prototype.installHooks = function (hooks) {
        var _this = this;
        if (hooks && hooks.length > 0) {
            hooks.forEach(function (hook) {
                if (hook.install) {
                    try {
                        hook.install(_this._options);
                    }
                    catch (err) {
                        console.warn('LoggerHook install failure', err);
                    }
                }
            });
        }
    };
    VueLogger.prototype.invokeHooks = function (hooks, event) {
        if (hooks && hooks.length > 0) {
            hooks.forEach(function (hook) {
                try {
                    hook.run(event);
                }
                catch (err) {
                    console.warn('LoggerHook run failure', err);
                }
            });
        }
    };
    VueLogger.prototype.getCallerInfo = function () {
        var e = new Error();
        if (e.stack) {
            try {
                var frames_1 = e.stack.split('\n');
                var callerFrameIndex = frames_1[0].startsWith('Error') ? 4 : 3;
                var callerFrame = e.stack.split('\n')[callerFrameIndex].trim().replace('(', '').replace(')', '');
                var functionName = void 0;
                if (callerFrame.indexOf('at ') > -1) {
                    functionName = callerFrame.substring(callerFrame.indexOf('at ') + 3, callerFrame.lastIndexOf(' ')).split('.').reverse()[0];
                }
                else if (callerFrame.indexOf('@') > -1) {
                    functionName = callerFrame.substring(0, callerFrame.indexOf('@'));
                }
                var callerLocationParts = callerFrame.split(':').reverse();
                var fileName = callerLocationParts[2].substring(Math.max(callerLocationParts[2].lastIndexOf('/'), callerLocationParts[2].lastIndexOf('\\')) + 1).split('?')[0];
                var lineNumber = callerLocationParts[1];
                return { functionName: functionName, fileName: fileName, lineNumber: lineNumber };
            }
            catch (err) {
                if (!isProduction) {
                    console.debug('vue-logger-plugin :: failed to determine caller function info');
                }
            }
        }
        return undefined;
    };
    Object.defineProperty(VueLogger.prototype, "enabled", {
        get: function () {
            return this._options.enabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VueLogger.prototype, "level", {
        get: function () {
            return this._options.level;
        },
        enumerable: false,
        configurable: true
    });
    VueLogger.install = install_1.install;
    return VueLogger;
}());
exports.default = VueLogger;
//# sourceMappingURL=logger.js.map